import * as api from './agentProfile.api'
import { GET_AGENT_PROFILE } from './agentProfile.constants'

export const getAgentProfileRequested = () => ({
  type: GET_AGENT_PROFILE.REQUESTED,
})

export const getAgentProfileSuccess = response => ({
  response,
  type: GET_AGENT_PROFILE.SUCCESS,
})

export const getAgentProfileError = error => ({
  error,
  type: GET_AGENT_PROFILE.FAILURE,
})

export const getAgentProfile = (agentId, cancelToken) => {
  return async dispatch => {
    dispatch(getAgentProfileRequested())
    try {
      const agentProfile = await api.getAgentProfile(agentId, cancelToken)
      dispatch(getAgentProfileSuccess(agentProfile))
      return agentProfile
    } catch (error) {
      dispatch(getAgentProfileError(error))
    }
  }
}
